/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Dashboard_Quick_ActionsInputs */

const en_seller_dashboard_quick_actions = /** @type {(inputs: Seller_Dashboard_Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quick Actions`)
};

const es_seller_dashboard_quick_actions = /** @type {(inputs: Seller_Dashboard_Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acciones rápidas`)
};

const fr_seller_dashboard_quick_actions = /** @type {(inputs: Seller_Dashboard_Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions rapides`)
};

const de_seller_dashboard_quick_actions = /** @type {(inputs: Seller_Dashboard_Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schnellaktionen`)
};

const ja_seller_dashboard_quick_actions = /** @type {(inputs: Seller_Dashboard_Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クイックアクション`)
};

const zh_seller_dashboard_quick_actions = /** @type {(inputs: Seller_Dashboard_Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`快捷操作`)
};

const ar_seller_dashboard_quick_actions = /** @type {(inputs: Seller_Dashboard_Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إجراءات سريعة`)
};

const id_seller_dashboard_quick_actions = /** @type {(inputs: Seller_Dashboard_Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tindakan Cepat`)
};

const it_seller_dashboard_quick_actions = /** @type {(inputs: Seller_Dashboard_Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Azioni Rapide`)
};

const ru_seller_dashboard_quick_actions = /** @type {(inputs: Seller_Dashboard_Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Быстрые действия`)
};

const pt_seller_dashboard_quick_actions = /** @type {(inputs: Seller_Dashboard_Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ações Rápidas`)
};

const ko_seller_dashboard_quick_actions = /** @type {(inputs: Seller_Dashboard_Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`빠른 실행`)
};

/**
* | output |
* | --- |
* | "Quick Actions" |
*
* @param {Seller_Dashboard_Quick_ActionsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_dashboard_quick_actions = /** @type {((inputs?: Seller_Dashboard_Quick_ActionsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Dashboard_Quick_ActionsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_dashboard_quick_actions(inputs)
	if (locale === "es") return es_seller_dashboard_quick_actions(inputs)
	if (locale === "fr") return fr_seller_dashboard_quick_actions(inputs)
	if (locale === "de") return de_seller_dashboard_quick_actions(inputs)
	if (locale === "ja") return ja_seller_dashboard_quick_actions(inputs)
	if (locale === "zh") return zh_seller_dashboard_quick_actions(inputs)
	if (locale === "ar") return ar_seller_dashboard_quick_actions(inputs)
	if (locale === "id") return id_seller_dashboard_quick_actions(inputs)
	if (locale === "it") return it_seller_dashboard_quick_actions(inputs)
	if (locale === "ru") return ru_seller_dashboard_quick_actions(inputs)
	if (locale === "pt") return pt_seller_dashboard_quick_actions(inputs)
	return ko_seller_dashboard_quick_actions(inputs)
});